module.exports = __webpack_public_path__ + "static/img/live-hr-advice-icon-and-name.73e81a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/live-hr-advice-icon-and-name.png
// module id = Y2sL
// module chunks = 0